import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import './index.css';
import quizApp from './reducers';
import App from './components/App';

const store = createStore(quizApp, applyMiddleware(thunk));

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('quizContainer')
);



// WEBPACK FOOTER //
// ./src/index.js